

import XHeader from 'vux/src/components/x-header/index.vue'
import Alert from 'vux/src/components/alert/index.vue'


export default {
components: {
XHeader,
Alert
},
data () {
return {
show: false,
message:"",
model:{mobile:"",code:"",type:4},
codeWord:false,
isCode:false,
sendVal: false,
timer:60,
sendStr:"发送验证码"
}
},
methods: {
goBack(){

this.$router.push({
path : '/auth/login',
query : {}
})
},
toNext:function(){


if(this.verifyMobile()){
return;
}

if(this.model.code == ""){
this.show=true;
this.message="验证码不能为空";
return;
}

if(!this.codeWord){
this.show=true;
this.message="请先发送验证码";
return;
}

this.$http.post(this.global.httpUrl + '/rest/v1/m/safe/forgetPassword/checkCode',this.model,{emulateJSON:true}).then(function(res){

if(res.body.success){
this.$router.push('/auth/fotgetPassword2?mobile='+this.model.mobile);
}else{
this.show=true
this.message=res.body.message
return;
}

},function(res){
console.log(res.status);
});

},
getCodes(){

if(this.verifyMobile()){
return;
}

this.$http.post(this.global.httpUrl + '/rest/v1/m/safe/forgetPassword/sendSms',this.model,{emulateJSON:true}).then(function(res){
if(!res.body.success){
this.show=true
this.message=res.body.message
return;
}

if(res.body.code==1){
this.show=true
this.message="发送成功"
this.timer = res.body.max;
this.codeWord= true;
} else if(res.body.code==-11) {
this.show=true
this.message="您今日已超过短信上限";
} else if(res.body.code==-1) {
this.show=true
this.message=res.body.message
} else if(res.body.code==(-12)){
this.message="一分钟之内只能发送一次验证码";

}

this.isCode = true;
let auth_timer = setInterval(()=>{  //定时器设置每秒递减
this.timer--;        
this.sendStr = this.timer+"s后重发";
if(this.timer<=0){
this.isCode = false;
this.sendStr = "发送验证码";    
clearInterval(auth_timer)
}
},1000);
this.show=true;

},function(res){
console.log(res.status);
});
},
verifyMobile:function(){
var mobile = this.model.mobile;

if(mobile == ""){
this.show=true ;
this.message="手机号码不能为空!";
return true;
}

if(!/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(mobile)){
this.show=true ;
this.message="手机号码格式不正确!";
return true;
}

return false;
}
}
}



// WEBPACK FOOTER //
// ./src/views/auth/fotgetPassword.vue